import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function WithdrawlStart_Stop() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // let user = "";
  const [referralApi, setreferralApi] = useState([]);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [currentPage2, setcurrentPage2] = useState(1);
  const [listPerpage2, setlistPerpage2] = useState(10);
  const [positionfilter, setpositionfilter] = useState("0");
  const [StatusFilter, setStatusFilter] = useState("1");
  const [allMember, setAllMember] = useState("");
  const [fromRegdate, setfromRegdate] = useState("");
  const [toRegdate, settoRegdate] = useState("");

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/WithdrawlStartStop",
        {
          loginid: userId,
          SearchTerm: search,
          fromdate: fromDate,
          todate: toDate,
          fromRegdate: fromRegdate,
          toRegdate: toRegdate,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("memberlist-->", responceRight.data.data);
      // setStakingdata(responceRight?.data?.data.records[0])
      responceRight = responceRight.data.data[0];
      setAllMember(responceRight);
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          id: `${item?.uid} `,
          login: (
            <>
              <a
                href={`https://royaljackpot.world/AdminLogin?user_id=${item.uid}&enpass=${item?.password}`}
                target="_blank"
                className="btn btn-lg btn-primary"
              >
                Login
              </a>
            </>
          ),
          user_id: `${item?.user_id} `,
          f_name: `${item?.f_name} `,
          Withdrawl_status: item.Withdrawl_status_ss,
          Withdrawl_status_color: (
            <>
              <button
                className={`${item?.Withdrawl_status === 0 ? "text-danger" : "text-success"
                  } btn`}
              >
                {item?.Withdrawl_status_ss}
              </button>
            </>
          ),
          staking: (
            <>
              <button
                className={`${item?.Withdrawl_status === 0 ? "btn-danger" : "btn-primary"
                  } btn`}
                onClick={() => Status_active(item?.uid, item?.Withdrawl_status)}
              >
                {item?.Withdrawl_status === 1 ? "Stop" : "Start"}
              </button>
            </>
          ),
          // edit: (
          //   <>
          //     <button
          //       type="button"
          //       className="btn btn-danger"
          //       onClick={() =>
          //         navigate(`/Edit_Details?userId=${item?.user_id}`)
          //       }
          //     >
          //       Edit
          //     </button>
          //   </>
          // ),
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const Status_active = async (id, Withdrawl_status) => {
    try {
      console.log("statevalue", Withdrawl_status);
      let status_value = Withdrawl_status;
      let status = 0;

      if (status_value == "1") {
        status = 0;
      } else {
        status = 1;
      }
       console.log("uid=>", id);
       console.log("status=>", status);
      let res = await API?.post(
        "/WithdrawlStartStopPost",

        {
          loginid: userId,
          uid: id,
          status: status,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("res_block", res);
      if ((res.data.success = "true")) {
        toast.success("Update Successfully ..");
        referral_API();
        // window.location.reload();
      } else {
        toast.error("Somthing Wrong");
      }
      console.log("MyActive", res.data.data);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const start_All = async (Withdrawl_status) => {
    try {
      console.log("statevalue", Withdrawl_status);
      let status_value = Withdrawl_status;

      let res = await API?.post(
        "/WithdrawlStartStopPost",

        {
          loginid: userId,
          uid: 0,
          status: status_value,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("res_block", res);
      if ((res.data.success = "true")) {
        toast.success("Update Successfully ..");
        referral_API();
        // window.location.reload();
      } else {
        toast.error("Somthing Wrong");
      }
      console.log("MyActive", res.data.data);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const Stop_All = async (Withdrawl_status) => {
    try {
      console.log("statevalue", Withdrawl_status);
      let status_value = Withdrawl_status;

      let res = await API?.post(
        "/WithdrawlStartStopPost",

        {
          loginid: userId,
          uid: 0,
          status: status_value,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("res_block", res);
      if ((res.data.success = "true")) {
        toast.success("Update Successfully ..");
        referral_API();
        // window.location.reload();
      } else {
        toast.error("Somthing Wrong");
      }
      console.log("MyActive", res.data.data);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const indexOfLastPost2 = currentPage2 * listPerpage2;
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2;
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost);
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage2,
    indexOfLastPost2
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "user_id" },
      { Header: "Name", accessor: "f_name" },
      { Header: "Withdrawl Status", accessor: "Withdrawl_status_color" },
      { Header: " Action", accessor: "staking" },
      // { Header: "Edit", accessor: "edit" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page content_page_hit">
        <div class="content">
          <div class="container">
            {/* <-- inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title">Withdrawl Start Stop</h4>
                  </div>
                  <div class="panel-body">
                    <form
                      action="/Admin/BulkRegistration"
                      method="post"
                      class="ng-pristine in-ip-1 ng-valid"
                    >
                      <div class="form-inline" role="form">
                        <div class="col-md-12">
                          <div class="col-lg-2 col-xl-2 col-md-3">
                            <label>User Id</label><br />
                            <input
                              class="form-control in-ip-1"
                              id="uid"
                              onChange={(e) => setSearch(e.target.value)}
                              name="uid"
                              placeholder="Search By User Id or Name or Email"
                              type="text"
                              value={search}
                            />
                          </div>
                          
                          <div class="col-lg-2 col-xl-2 col-md-3">
                            <br />
                            <input
                              type="reset"
                              id="btnsearch"
                              formmethod="get"
                              onClick={() => (
                                referral_API(), setcurrentPage2(1)
                              )}
                              class="btn btn-lg btn-primary"
                              value="Search"
                            />
                          </div>
                          <div class="col-lg-2 col-xl-2 col-md-3">
                            <br />
                            <input
                              type="reset"
                              id="btnsearch"
                              formmethod="get"
                              onClick={() => (
                                start_All(1)
                              )}
                              class="btn btn-lg btn-primary"
                              value="Start All"
                            />
                          </div>
                          <div class="col-lg-2 col-xl-2 col-md-3">
                            <br />
                            <input
                              type="reset"
                              id="btnsearch"
                              formmethod="get"
                              onClick={() => (
                                Stop_All(0)
                              )}
                              class="btn btn-lg btn-primary"
                              value="Stop All"
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-default">
                  <div class="panel-body" style={{ overflow: "scroll" }}>
                    <Table data={currentPostleft} columns={my_team.cols} />

                    <Table_Buttons
                      indexOfFirstPage={indexOfFirstPage2}
                      indexOfLastPost={indexOfLastPost2}
                      setcurrentPage={setcurrentPage2}
                      currentPage={currentPage2}
                      totalData={leftreferralApi.length}
                      listPerpage={listPerpage2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WithdrawlStart_Stop;
